<script setup lang="ts">
import CustomButton from '@/components/CustomButton.vue';
import { useActionPointStore } from '@/stores/actionPoint';
import { useGlobalStore } from '@/stores/global';
import type { ActionPoint } from '@/types/actionPoint';
import type { Note } from '@/types/note';
import { required } from '@/utils/validation';
import { ref, useTemplateRef } from 'vue';

const actionPointStore = useActionPointStore();
const globalStore = useGlobalStore();

const props = defineProps<{
    // TODO: change to Entity in the future to allow placing notes on other entities
    actionPointId: ActionPoint['_id'];
}>();

const note = ref({} as Note);
const form = useTemplateRef('form');
const files = ref<File[]>([]);
const emit = defineEmits(['note-created']);

async function createNote() {
    const validationResult = await form.value?.validate();
    if (!validationResult?.valid) return;

    const result = await actionPointStore.createNote(props.actionPointId, note.value, files.value);

    if (result.status === 201) {
        emit('note-created', result.object, files.value);
        form.value?.reset();
        files.value = [];
    }
}
</script>

<template>
    <v-form ref="form" @submit.prevent>
        <v-text-field v-model="note.title" required :rules="[required]" label="Onderwerp"/>
        <v-textarea v-model="note.body" label="Inhoud" required :rules="[required]"/>
        <v-file-input v-model="files" multiple label="Bijlagen toevoegen" show-size :chips="true"/>
        <CustomButton class="mt-2" @click="createNote" text="Aanmaken" :loading="globalStore.isLoading"/>
    </v-form>
</template>
